// Copyright (C) CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';
import React from 'react';
import Button from 'antd/lib/button';
import { ExpandOutlined } from '@ant-design/icons';

import CVATTooltip from 'components/common/cvat-tooltip';
import { t } from 'utils/i18n';

export default function FitButton({ onFit }: { onFit(): void }): JSX.Element {
    return (
        <CVATTooltip title={t('Fit to screen')}>
            <Button
                aria-label={t('Fit to screen')}
                className='cvat-workspace-fit-button'
                icon={<ExpandOutlined />}
                onClick={onFit}
            />
        </CVATTooltip>
    );
}
